import "./TagMore.scss"

import React, { FunctionComponent } from "react"

import Text from "components/Text/Text"
import iconMoreArrow from "assets/img/icon-more-arrow.svg"
import iconMoreArrowWhite from "assets/img/icon-more-arrow-white.svg"

export interface ITagMoreProps {
    label: string,
    isExpanded?: boolean
}

const TagMore: FunctionComponent<React.PropsWithChildren<ITagMoreProps>> = ({
    label,
    isExpanded
}) => {

    return (
        <div className={`tag-more ${isExpanded ? 'tag-more--expanded' : ''}`}
            aria-expanded={isExpanded}
            data-testid="tag-more">
            <Text className="tag-more__text" type="pSmallest"><strong title={label}>{label}</strong></Text>
            <img src={iconMoreArrow} className="tag-more__icon tag-more__icon--default" alt="" />
            <img src={iconMoreArrowWhite} className="tag-more__icon tag-more__icon--hover" alt="" />
        </div>
    )
}

export default TagMore
